import React from "react";
import PropTypes from "prop-types";
import MDBox from "shared/components/MDBox";
import TableContent from "./TableLazoContent";

function TableLazo({ refreshFlag, onError, lot }) {
  return (
    <MDBox>
      <TableContent refreshFlag={refreshFlag} onError={onError} lot={lot} />
    </MDBox>
  );
}

TableLazo.propTypes = {
  refreshFlag: PropTypes.bool,
  onError: PropTypes.func,
  lot: PropTypes.number,
};

TableLazo.defaultProps = {
  refreshFlag: false,
  onError: null,
  lot: null,
};

export default TableLazo;
